import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-invventory',
    templateUrl: './invventory.component.html',
    styleUrls: ['./invventory.component.scss'],
    standalone: false
})
export class InvventoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
